import { render, staticRenderFns } from "./IconEnviromentClient.vue?vue&type=template&id=6199086c&scoped=true&lang=pug"
import script from "./IconEnviromentClient.vue?vue&type=script&lang=js"
export * from "./IconEnviromentClient.vue?vue&type=script&lang=js"
import style0 from "./IconEnviromentClient.vue?vue&type=style&index=0&id=6199086c&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6199086c",
  null
  
)

export default component.exports